import { render, staticRenderFns } from "./contenta.vue?vue&type=template&id=7dbffed2&scoped=true&"
import script from "./contenta.vue?vue&type=script&lang=js&"
export * from "./contenta.vue?vue&type=script&lang=js&"
import style0 from "./contenta.vue?vue&type=style&index=0&id=7dbffed2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbffed2",
  null
  
)

export default component.exports